import 'swiper/css/effect-fade';

import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
import { type SwiperOptions } from 'swiper/types';

const swiperParams: SwiperOptions = {
  allowSlideNext: false,
  allowSlidePrev: false,
  allowTouchMove: false,
  simulateTouch: false,
  noSwiping: true,
  modules: [EffectFade],
  effect: 'fade',
  speed: 400,
  fadeEffect: {
    crossFade: true, // Ermöglicht einen smootheren Übergang
  },
  autoHeight: true,
  noSwipingClass: 'swiper-slide',
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
};

const swiper = new Swiper('.swiper-container', {
  ...swiperParams,
  on: {
    slideChangeTransitionStart: function () {
      const jobElement = document.getElementById('job');
      if (jobElement) {
        jobElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    },
  },
});

// Event Listener für den "Jetzt starten"-Button
document.getElementById('start-button')?.addEventListener('click', () => {
  swiper.allowSlideNext = true;
  swiper.slideNext();
});

document.getElementById('back-button')?.addEventListener('click', () => {
  swiper.allowSlidePrev = true;
  swiper.slidePrev();
});

// MutationObserver to detect visibility changes of the success message element
const successMessageElement: HTMLElement | null = document.querySelector(
  '.success-message.job.w-form-done'
);

if (successMessageElement) {
  const observerCallback = (mutations: MutationRecord[]): void => {
    mutations.forEach((mutation: MutationRecord) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        // Check if the element is visible by verifying that display is not "none"
        const computedStyle = window.getComputedStyle(successMessageElement);
        if (computedStyle.display !== 'none') {
          swiper.updateAutoHeight();
        }
      }
    });
  };

  const observerOptions: MutationObserverInit = {
    attributes: true,
    attributeFilter: ['style'],
  };

  const observer = new MutationObserver(observerCallback);
  observer.observe(successMessageElement, observerOptions);
}
